import * as React from 'react';
import { GenericActionTile } from './GenericActionTile';

export function ReportTile(props:
    {
        reportType: string;
        entityName: string,
        entityCode: string,
        afrYear: number,
        tileTitle: string;
        tileDescription: string;
        isEnabled: boolean;
        isLoading: boolean | null;
        isForPublicReports?: boolean | null;
        clickAction: (atype: string, ename: string, ecode: string, aYear: number) => void
    }) {

    return (
        <GenericActionTile
            actionType={props.reportType}
            entityName={props.entityName}
            entityCode={props.entityCode}
            afrYear={props.afrYear}
            tileTitle={props.tileTitle}
            tileDescription={props.tileDescription}
            icon="bi bi-download"
            isEnabled={props.isEnabled}
            isLoading={props.isLoading}
            isForPublicReports={props.isForPublicReports}
            clickAction={props.clickAction}
        />
    );
}


